import React, {useEffect} from "react";
import "./bottom_navy.css";
import {BrowserRouter, Routes, Route, Link} from "react-router-dom"
import QRPage from "./qr.js";
import {useState} from 'react';
import {utils} from "./utils/utils";

const BottomNav = () => {
    const [token, setToken, secretKey] = useState('');

    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        if (storedToken) {
            setToken(storedToken);
        }
    }, []);

    const handleEcharmClick = () => {
        //https://eruri.kangwon.ac.kr
        //utils.ssoLink(token,'https://gwportal.kangwon.ac.kr/portal/default/shortcut/prof/lms.page','echarm');  => 교수
        //utils.ssoLink(token,'https://gwportal.kangwon.ac.kr/portal/default/shortcut/empl/lms.page','echarm');  => 직원
        //utils.ssoLink(token,'https://gwportal.kangwon.ac.kr/portal/default/shortcut/stu/lms.page','echarm');   => 학생

        utils.ssoLink(token,'https://eruri.kangwon.ac.kr/local/ubion/sso/sso.php','echarm');
        // window.open('https://eruri.kangwon.ac.kr', '_blank');
        // alert('E참뜰 버튼이 클릭 되었습니다.');
    };
    const handleHIGHClick = () => {
        utils.ssoLink(token, 'https://high.gwnu.ac.kr', 'high');
        //window.open('https://gwportal.kangwon.ac.kr/user/login.face?ssoReturn=https://high.gwnu.ac.kr/login/a/n/ssoLoginProc.do?targetUrl=/clientMain/a/t/main.do', '_blank');
        // alert('HIGH 버튼이 클릭 되었습니다.');
        // 또는 다른 동작을 수행하거나 페이지를 이동할 수 있습니다. https://high.gwnu.ac.kr/ 사용자 브라우져 새창으로
    };


    const handlesettingClick = () => {
        // localStorage에서 토큰 제거
        localStorage.removeItem('token');
        // 로그아웃 상태 처리
        setToken('');
        //alert('setting 버튼이 클릭 되었습니다.');
        window.location.href = '/'; // 또는 다른 주소로 변경
    };
    return (

        <nav className="wrapper">
            <Link className="home" to="/">
                <div className="home"></div>
            </Link>
            <div className="Echarm" onClick={handleEcharmClick}></div>
            <div className="HIGH" onClick={handleHIGHClick}></div>
            <div className="setting" onClick={handlesettingClick}></div>
        </nav>

    );
};

export default BottomNav;

{/* <div className="setting" onClick={handlesettingClick}></div> */
}